import { SectionScan } from "../types/types"
import { genericRequest, sectionScanRoute } from "./service"

/**
 * Gets a list of all section scans related to a given workflow.
 * 
 * @param workflowId of the related section scans
 * 
 * @returns list of all section scans related to the workflow
 */
export const getSectionScans = async (workflowId: number): Promise<SectionScan[] | Error> => {
  return genericRequest({ url: `${sectionScanRoute}/sections/${workflowId}`, method: "GET" })
}

/**
 * Adds a section scan to the database.
 * 
 * @param sectionScan to store in the database
 * 
 * @returns uploaded section scan
 */
export const addSectionScan = async (sectionScan: SectionScan, workflowId: number): Promise<SectionScan | Error> => {
  const body = JSON.stringify(sectionScan)
  return genericRequest({ url: `${sectionScanRoute}/${workflowId}`, method: "POST", body: body })
}